import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_BASE_HREF } from '@angular/common';

import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { AppRoutingModule } from './app-routing.module';
import { NavModule } from '../nav/nav.module';
import { ApiModule } from '../api';
import { SessionModule } from '../session';
import { UserModule } from '../user';
import { DossierModule } from '../dossier';
import { DossierModelModule } from '../dossier-model';
import { LinkGroupModule } from '../link-group';
import { DataLinkModule } from '../data-link';
import { RecordLinkModule } from '../record-link';
import { RecordModule } from '../record';
import { OperationModule } from '../operation';
import { RevisionModule } from '../revision';
import { DocumentModule } from '../document';
import { ExecutionModule } from '../execution';
import { SettingsModule } from '../settings';
import { OrganigrammeModule } from '../organigramme';

import { AppComponent } from './app.component';
import { OutletComponent } from './outlet.component';
import { ReportModule } from '../report';
import { CapitalisationModule } from '../capitalisation';


// Locales
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { SLModule } from '../shares-ledger';
import { DLModule } from '../documents-ledger';
import { INPIModule } from '../inpi';

registerLocaleData(localeFr, 'fr');

const imports = [
  BrowserModule,
  HttpClientModule,
  BrowserAnimationsModule,

  NavModule,
  ApiModule,
  SessionModule,
  SharedUiModule,
  UiModule,

  DossierModule,
  DossierModelModule,

  LinkGroupModule,

  DataLinkModule,
  
  RecordLinkModule,
  RecordModule,

  OperationModule,
  RevisionModule,
  DocumentModule,

  ExecutionModule,

  SettingsModule,
  UserModule,
  AppRoutingModule,

  OrganigrammeModule,

  ReportModule,

  CapitalisationModule,

  INPIModule,

  SLModule,
  DLModule,
];

@NgModule({
  imports,
  declarations: [
    AppComponent,
    OutletComponent
  ],
  providers: [
    // Define this constant instead of using <base href="/">
    // This should allow Firefox to show SVG icons
    {
      provide: APP_BASE_HREF,
      useValue: '/'
    }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
